<template>
  <router-view />
  <ModernConfirmModal />
</template>

<script>
import axios from "axios";
import ModernConfirmModal from "./components/ModernConfirmModal.vue";

const API = process.env.VUE_APP_API_URL;

export default {
  name: "App",
  components: {
    ModernConfirmModal
  },
  mounted() {
    this.sendHeartbeat();
    this.heartbeatInterval = setInterval(this.sendHeartbeat, 120000);
  },
  beforeUnmount() {
    if (this.heartbeatInterval) clearInterval(this.heartbeatInterval);
  },
  methods: {
    sendHeartbeat() {
      try {
        const token = sessionStorage.getItem("token") || localStorage.getItem("token");
        const userStr = sessionStorage.getItem("user") || localStorage.getItem("user");
        if (token && userStr && userStr !== "undefined") {
          const user = JSON.parse(userStr);
          axios.post(
            `${API}/audit-logs/heartbeat`,
            { user }
          ).catch(() => {});
        }
      } catch (e) {}
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
